export class ResetState {
    public static readonly type = '[State] ResetState';
}
